module.exports = __webpack_public_path__ + "d90270ff6ff3d23c2746fe3ec752b1a2.png";